<template>
    <form @submit.prevent="handleSubmit(item)" novalidate ref="form">
        <div class="row">
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.amount) }">
                <label for="_amount" class="control-label">Kwota</label>
                <b-input-group :right="currencyName">
                    <input type="text" v-model="item.amount" placeholder="" id="_amount" class="form-control"/>
                </b-input-group>
                <span v-if="errors && errors.amount" class="help-block" id="_amount_helpBlock">{{ errors.amount
                    }}</span>
            </div>
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.paymentDate) }">
                <label for="_paymentDate" class="control-label">Data płatności</label>
                <el-date-picker
                        id="_paymentDate"
                        v-model="item.paymentDate"
                        type="date"
                        placeholder="">
                </el-date-picker>
                <span v-if="errors && errors.paymentDate" class="help-block"
                      id="_paymentDate_helpBlock">{{ errors.paymentDate }}</span>
            </div>
        </div>
    </form>
</template>

<script>

  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      currencyName: {
        type: String,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    data: function () {
      return {
        defaultData: {
          paymentDate: new Date(),
        }
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : Object.keys(this.values).length > 0 ? this.values : this.defaultData;
      }
    },
    methods: {
      sendForm(){
        this.handleSubmit(this.item);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FormPayment.vue?19f67816